import React from "react";

const Setting = () => {
  return (
    <div className="mt-20">
      <h1>Setting Page</h1>
    </div>
  );
};

export default Setting;
